import React, { useState, useEffect } from "react";
import Header from "../../../Components-2/Header/Header";
import Sidebar1 from "../../../Components-2/Sidebar1";
import Footer from "../../../Components-2/Footer";
import ScanbyAirway from "./ScanbyAirway";
import ScanbyManifest from "./ScanbyManifest";
import ScanbyDRSNo from "./ScanbyDRSNo";
import { useLocation } from "react-router-dom";
import PendingScan from "./PendingScan";

function Inscan() {
  // Get permissions from localStorage
  const permissions = JSON.parse(localStorage.getItem("Login")) || {};
  const has = (key) => permissions[key] === 1;

  // Tabs definition with permission checks
  const tabs = [
    { id: "pen", label: "Pending Scan", component: <PendingScan />, show: has("PendingScan") },
    { id: "airway", label: "Scan by Docket No", component: <ScanbyAirway />, show: has("ScanbyDocketNo") },
    { id: "manifest", label: "Inscan Process View", component: <ScanbyManifest />, show: has("InscanProcessView") },
    { id: "drs", label: "Inscan by DRS No", component: <ScanbyDRSNo />, show: has("InscanbyDRSNo") },
  ];

  // Only show tabs the user has access to
  const visibleTabs = tabs.filter((t) => t.show);
  const location=useLocation();
  const [activeTab, setActiveTab] = useState(location?.state?.tab || null);

  // Auto-select the first visible tab
  useEffect(() => {
    if (activeTab === null && visibleTabs.length > 0) {
      setActiveTab(visibleTabs[0].id);
    }
  }, [visibleTabs, activeTab]);

  return (
    <>
      <Header />
      <Sidebar1 />

      <div id="main-body">
        <div className="container">

          {/* Tab Headers */}
          <nav>
            {visibleTabs.map((tab) => (
              <label
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={activeTab === tab.id ? "active-tab" : ""}
              >
                {tab.label}
              </label>
            ))}

            {/* Slider */}
            {activeTab && visibleTabs.length > 0 && (
              <div
                className="slider"
                style={{
                  left: `${visibleTabs.findIndex((t) => t.id === activeTab) * (100 / visibleTabs.length)}%`,
                  width: `${100 / visibleTabs.length}%`,
                }}
              />
            )}
          </nav>

          {/* Tab Content */}
          <section>
            {visibleTabs.find((t) => t.id === activeTab)?.component}
          </section>

        </div>
        <Footer />
      </div>
    </>
  );
}

export default Inscan;
